<div class="panneau-list-retrocessions__container">
	<di-list-retrocessions
		[retrocessions]="retrocessions" 
		[utilisateurs]="utilisateurs"
		[selectedRetrocessionId]="selectedRetrocessionId"
		[isMobile]="true"
		(onCreateRetrocession)="createNewRetrocession()"
		(onSelectRetrocession)="displayRetrocessionDetails($event)"
	></di-list-retrocessions>
</div>